// Force product image gallery to always start on first image
document.addEventListener('DOMContentLoaded', function () {
  var checkFlickity = setInterval(function () {
    var slider = document.querySelector('.product-slideshow');
    if (slider && window.Flickity) {
      var flkty = Flickity.data(slider);
      if (flkty) {
        flkty.select(0, false, true);
        clearInterval(checkFlickity);
      }
    }
  }, 100);

  // Stop checking after 3 seconds regardless
  setTimeout(function () { clearInterval(checkFlickity); }, 3000);
});